
    import "./src/global.css";
    import App from "./src/App.svelte";
    import { mount } from "svelte";
    mount(App, {
      target: document.body,
      props: {},
    });
  